import React from 'react';
import { Helmet } from 'react-helmet';
import DepartmentsHome from '../../departments/DepartmentsHome';

const Departments = () => {
  return (
    <>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Hospital Departments</title>
        <meta name="description" content="Explore hospital departments at Columbiaa Hospital, Kasturi Nagar, Bangalore. Best multi-speciality hospital offering cardiology, neurology, neurosurgery, orthopedics, oncology, nephrology, obstetrics and gynaecology, gastroenterology, ENT, dermatology, pulmonology, urology, emergency medicine, critical care, anesthesiology, plastic surgery, psychiatry, physiotherapy, dental, and more. Expert doctors and advanced treatments." />
        <meta name="keywords" content="Columbiaa Hospital, hospital departments, best multi-speciality hospital, hospital in Kasturi Nagar, hospital in Bangalore, cardiology department, neurology department, neurosurgery department, orthopedics department, oncology department, nephrology department, dialysis department, obstetrics and gynaecology, gastroenterology, ENT department, dermatology, pulmonology, urology, emergency medicine, critical care, anesthesiology, plastic surgery, psychiatry, physiotherapy, dental hospital, Bangalore hospital, 24/7 hospital, top hospital near me, multi-speciality hospital near me, hospital near Kasturi Nagar, healthcare Bangalore, specialist doctor Bangalore, Dr H V Satish Babu" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Hospital Departments" />
        <meta property="og:description" content="Explore all hospital departments at Columbiaa Hospital, the best multi-speciality hospital in Kasturi Nagar, Bangalore. Expert care in cardiology, neurology, orthopedics, oncology and more." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/departments" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/departments" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <section
        className="page-title py-5"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
        aria-label="Hospital Departments - Columbiaa Hospital, Kasturi Nagar, Bangalore"
      >
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
          aria-hidden="true"
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-12 col-md-10 text-center"
              data-aos="fade-right"
            >
              <div className="title-box my-4 my-md-0">
                <h1 className="display-4" aria-label="Our Departments">Our Departments</h1>
                <p className="lead" aria-label="Columbiaa Hospital - Your Health Care Partner">
                  Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <DepartmentsHome/>
    </>
  );
};

export default Departments;
